import { TextDecorator } from "@faire/web-api--source/indigofair/data/TextDecorator";
export var getDecoratorValuesCSS = function(decorators) {
    var css = {};
    if (!decorators) {
        return css;
    }
    decorators.forEach(function(decorator) {
        switch(decorator){
            case TextDecorator.STRIKE_THROUGH:
                css["textDecoration"] = "line-through";
                break;
            case TextDecorator.UNDERLINE:
                css["textDecoration"] = "underline";
                break;
            default:
                break;
        }
    });
    return css;
};
